import Modal from 'components/Modal';
import styles from './ManualChargeModal.module.scss';
import Typography from 'components/Typography';
import DataTable from 'components/DataTable';
import {DataTableSchemaItem} from 'types/ui';
import Button from 'components/Button';
import Select from 'components/Select';
import {ManualChargeMethod, ManualPayerType, TransactionType} from 'types';
import {
  MANUAL_PAYER_TYPE_OPTIONS,
  MANUAL_PAYER_TYPE_OPTIONS_LABELS,
  MANUAL_PAYMENT_TYPE_OPTIONS,
  MANUAL_PAYMENT_TYPE_OPTIONS_LABELS,
} from 'constants/select-options';
import {formatPrice} from 'utils/format-price';
import {UseFormReturn} from 'react-hook-form';
import {ManualCharge} from 'pages/RequestDetails/useRequestDetails';
import TextField from 'components/TextField';
import FeatureGuard from 'components/FeatureGuard';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  schema: DataTableSchemaItem[];
  data: any[];
  onChargeManually: () => void;
  isCharging: boolean;
  disabled: boolean;
  copayItems: any[];
  form: UseFormReturn<ManualCharge>;
  manualChargeType: TransactionType;
}

function ManualChargeModal({
  isOpen,
  onClose,
  schema,
  data,
  onChargeManually,
  isCharging,
  disabled,
  form,
  copayItems,
  manualChargeType,
}: Props) {
  const manualPaymentType = form.watch('payment_method');
  const manualPayerType = form.watch('payer_type');
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
      <Typography variant="h1">Manual Charge</Typography>
      <DataTable
        schema={schema}
        data={data || []}
        wrapperStyle={styles.dataTable}
      />

      <div className={styles.modalContent}>
        <div className={styles.totalContainer}>
          <Typography variant="label">Total</Typography>
          <Typography variant="h3">
            {formatPrice(
              copayItems?.reduce(
                // Here we are using the amount_due field but actually we are using the payable_amount_due field while calculating the copay items.
                (pr: number, curr: any) => pr + Number(curr?.amount_due),
                0
              )
            )}
          </Typography>
        </div>

        <Typography variant="label">Payment Method</Typography>
        <Select
          className={styles.select}
          placeholder="Select Payment Method"
          value={
            manualPaymentType && {
              label:
                MANUAL_PAYMENT_TYPE_OPTIONS_LABELS[
                  manualPaymentType as ManualChargeMethod
                ],
              value: manualPaymentType,
            }
          }
          onChange={(value) =>
            form.setValue('payment_method', value?.value as ManualChargeMethod)
          }
          options={MANUAL_PAYMENT_TYPE_OPTIONS}
        />
        <FeatureGuard feature="hasPayerTypeOnCharge">
          <Typography variant="label">Payer Type</Typography>
          <Select
            className={styles.select}
            placeholder="Select Payer Type"
            value={
              manualPayerType && {
                label:
                  MANUAL_PAYER_TYPE_OPTIONS_LABELS[
                    manualPayerType as ManualPayerType
                  ],
                value: manualPayerType,
              }
            }
            onChange={(value) =>
              form.setValue('payer_type', value?.value as ManualPayerType)
            }
            options={MANUAL_PAYER_TYPE_OPTIONS}
          />
          {manualChargeType === 'payable' && (
            <TextField
              label="Payer Name"
              placeholder="Enter Payer Name"
              {...form.register('payer_name')}
            />
          )}
        </FeatureGuard>
        <div className={styles.actions}>
          <Button
            onClick={onChargeManually}
            size="md"
            loading={isCharging}
            disabled={disabled}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
}
export default ManualChargeModal;
